import Tanakayuf1 from '../../../Media/Fasilitas BSD/Tanakayu/Tanakayu (1).webp'
import Tanakayuf2 from '../../../Media/Fasilitas BSD/Tanakayu/Tanakayu (2).webp'





const Tanakayufimages =[
Tanakayuf1,Tanakayuf2
]

export default Tanakayufimages;